import * as React from 'react';

export const MaterialBlockOut: Function = (
  props: React.SVGProps<SVGSVGElement>,
): JSX.Element => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 88.45 88.45"
      {...props}
    >
      <defs>
        <clipPath id="blackout-clip-path">
          <circle cx="44.22" cy="44.22" r="36.5" fill="none" />
        </clipPath>
      </defs>
      <circle
        cx="44.22"
        cy="44.22"
        r="43.5"
        fill="#fff"
        stroke="#27375f"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.45"
      />
      <g clipPath="url(#blackout-clip-path)">
        <path d="M64.73 31.12a.8.8 0 00-1.09-.29l-3.87 2.24a.79.79 0 00-.29 1.08.8.8 0 001.09.29l3.87-2.24a.79.79 0 00.29-1.08zM64.44 51.83l-3.87-2.24a.8.8 0 00-1.09.29.79.79 0 00.29 1.12l3.87 2.24a.79.79 0 10.8-1.37zM45.92 57.69a.79.79 0 00-.86.73V63a.81.81 0 00.74.86.8.8 0 00.85-.74v-4.58a.79.79 0 00-.73-.85zM31.94 33.07l-3.87-2.24a.8.8 0 00-1.09.29.79.79 0 00.29 1.08l3.87 2.24a.8.8 0 001.09-.29.79.79 0 00-.29-1.08zM45.92 20.16a.8.8 0 00-.86.74v4.59a.8.8 0 001.59 0V21a.8.8 0 00-.73-.84zM38.28 27.3L36 23.43a.79.79 0 00-1-.29.8.8 0 00-.29 1.09l2.19 3.87a.8.8 0 001.38-.8zM46 34.94h-.12a7.08 7.08 0 00-7.1 7.06.8.8 0 00.8.8.79.79 0 00.79-.8 5.48 5.48 0 015.48-5.48.8.8 0 00.86-.74.8.8 0 00-.71-.84zM67.59 42a.79.79 0 00-.74-.73h-4.47a.78.78 0 00-.85.73.8.8 0 00.73.86h4.59a.81.81 0 00.74-.86zM29.45 41.22h-4.59a.8.8 0 00-.74.86.79.79 0 00.74.73h4.47a.8.8 0 00.12-1.59z" />
        <path d="M45.86 30.31A11.71 11.71 0 1057.56 42a11.72 11.72 0 00-11.7-11.69zM53 49.18a10.12 10.12 0 01-14.3-14.32A10.11 10.11 0 0153 49.18zM57 59.8l-2.2-3.87a.79.79 0 00-1.08-.29.8.8 0 00-.29 1.09l2.24 3.87a.79.79 0 001.08.29.8.8 0 00.25-1.09zM56.78 23.14a.8.8 0 00-1.09.29l-2.23 3.87a.79.79 0 00.28 1.09.8.8 0 001.09-.29l2.24-3.87a.8.8 0 00-.29-1.09zM38 55.64a.79.79 0 00-1.08.29l-2.25 3.87a.8.8 0 00.33 1.09.79.79 0 001-.29l2.24-3.87a.8.8 0 00-.24-1.09zM32.23 49.88a.8.8 0 00-1.09-.29l-3.87 2.24a.79.79 0 00-.27 1.08.8.8 0 001.09.29l3.85-2.2a.79.79 0 00.29-1.12z" />
        <path fill="#27375f" d="M-8.72-9.13h53v108h-53z" />
      </g>
    </svg>
  );
};
